@if(training) {
  <div class="h-100">
    <div class="top-cta">
      <dx-text-box
        #searchInputBox
        icon="search"
        width="300px"
        [label]="'EMPLOYEE.OVERVIEW.FIND-EMPLOYEES' | translate"
        stylingMode="filled"
        labelMode="floating"
        stylingMode="outlined"
        value=""
        valueChangeEvent="input"
        (onValueChanged)="onTableSearch($event)"
      >
        <dxi-button
          name="search"
          type="danger"
          location="before"
          [options]="{ icon: 'search', type: 'default', disabled: true }"
        ></dxi-button>
      </dx-text-box>

      <dx-button
        class="additional-participants"
        [text]="'+ ' + ('COMPLETE-TRAINING.ADD-ADDITIONAL-PARTICIPANTS' | translate)"
        type="default"
        (click)="onAddParticipants()"
      ></dx-button>
    </div>

    @if(inactivePersons.length !== 0) {
      <div class="active-users">
        <dx-button
          type="default"
          stylingMode="text"
          class="action"
          (onClick)="onActivateAllUsers()"
        >
          <span class="activate-users-content">
            {{ 'COMPLETE-TRAINING.ACTIVE-ALL-INACTIVE-USERS' | translate }}
            <i class="fa-solid fa-toggle-off action-icon toggle-icon"></i>
          </span>
        </dx-button>
      </div>
    }
    
    <dx-data-grid
      #dataGrid
      [dataSource]="selectedPersons"
      keyExpr="id"
      [showBorders]="false"
      [showColumnLines]="false"
      [showRowLines]="true"
      [hoverStateEnabled]="true"
      [columnAutoWidth]="true"
      [allowColumnResizing]="true"
      [columnResizingMode]="'nextColumn'"
      [paging]="{ enabled: true, pageSize: 10 }"
    >
      <dxo-header-filter [visible]="true"></dxo-header-filter>

      <dxo-pager
        [allowedPageSizes]="[10, 20, 50]"
        displayMode="full"
        [showInfo]="true"
        [showPageSizeSelector]="true"
        [showNavigationButtons]="true"
      ></dxo-pager>

      <dxi-column
        width="50"
        cellTemplate="statusCellTemplate"
        alignment="center"
        [allowSorting]="false"
        [allowFiltering]="false"
      >
        <div *dxTemplate="let data of 'statusCellTemplate'">
          @if(data.data.isUnknownUser || data.data.inactive) {
            <span class="highlight-text">!</span>
          }
        </div>
      </dxi-column>

      @for(column of personsColumns; track $index) {
        <dxi-column
          [cssClass]="column.cssClass"
          [caption]="column.caption"
          [name]="column.name || null"
          [dataField]="column.dataField"
          [cellTemplate]="column.cellTemplate"
          [allowFiltering]="column.disableFiltering ? false : true"
          [calculateDisplayValue]="column.calculateDisplayValue"
          [calculateSortValue]="column.calculateSortValue"
          [calculateCellValue]="column.cellValue"
          [dataType]="column.cellType"
          [allowEditing]="column.allowEditing"
          [visible]="column.visible"
        ></dxi-column>
      }

      @if(isIDDTrainingType) {
        <dxi-column
          [caption]="'COMMON.FIELDS.IDD-TIME-IN-MINUTES' | translate"
          dataField="iddTimeMinutes"
          alignment="right"
          headerAlignment="right"
          [allowSorting]="true"
          [allowFiltering]="true"
          cellTemplate="iddTimeTemplate"
        >
          <div *dxTemplate="let data of 'iddTimeTemplate'">
            <div class="idd-time-container">
              <dx-number-box
                [(value)]="data.data.iddTimeMinutes"
                [width]="125"
                [min]="0"
                [step]="1"
                format="#0"
                [showSpinButtons]="true"
                stylingMode="outlined"
                [inputAttr]="{
                  class: data.data.iddTimeMinutes !== trainingIDDTime
                    ? 'idd-time-changed'
                    : 'idd-time-default'
                }"
                (onValueChanged)="onIddTimeChanged(data.data, $event)"
              ></dx-number-box>
            </div>
          </div>
        </dxi-column>
      }

      <dxi-column
        dataField="isManuallyAdded"
        caption=""
        width="120"
        cellTemplate="manuallyAddedTemplate"
        alignment="center"
        [allowSorting]="false"
        [allowFiltering]="false"
      >
        <div *dxTemplate="let data of 'manuallyAddedTemplate'">
          @if(data.data.isManuallyAdded) {
            <span class="manually-added">
              {{ 'COMMON.MANUAL' |  translate }}
            </span>
          }
        </div>
      </dxi-column>

      <dxi-column
        cellTemplate="actionsCellTemplate"
        width="200"
        alignment="center"
        [allowSorting]="false"
        [allowFiltering]="false"
      >
        <div *dxTemplate="let data of 'actionsCellTemplate'" >
          <div class="cell-actions-container">
            
            @if(data.data.isUnknownUser) {
              <dx-button
                [hint]="'COMMON.ADD' | translate"
                type="success"  
                stylingMode="text"
                class="action"
                (onClick)="onCreateProfile(data.data)"
              >
                <i class="fa-solid fa-user-plus action-icon"></i>
              </dx-button>
            }

            @if(data.data.inactive) {
              <dx-button
                [hint]="'COMMON.ACTIVATE' | translate"
                type="default"
                stylingMode="text"
                class="action"
                (onClick)="onActivateUser(data.data)"
              >
                <i class="fa-solid fa-toggle-off action-icon toggle-icon"></i>
              </dx-button>
            }

            @if(data.data.eSignature) {
              <app-esignature-tooltip 
                [eSignatureImageUrl]="data.data.eSignature"
              />
            }

            @if(!data.data.isManuallyAdded) {
              <dx-button
                [hint]="'COMMON.MERGE' | translate"
                type="default"
                stylingMode="text"
                class="action"
                (onClick)="onMergePerson(data.data)"
              >
                <i class="fa-solid fa-code-merge action-icon"></i>
              </dx-button>
            }

            <dx-button
              [hint]="'COMMON.DELETE' | translate"
              type="danger"
              stylingMode="text"
              class="action"
              (onClick)="onDeletePerson(data.data)"
            >
              <i class="fa-solid fa-trash-can action-icon"></i>
            </dx-button>
          </div>
        </div>
      </dxi-column>
    </dx-data-grid>
  </div>
}

@if(showActivateUserModal && selectedActivatePersonId) {
  <app-activate-user-modal
    [showModal]="showActivateUserModal"
    [personId]="selectedActivatePersonId"
    (onActivate)="onUserActivated()"
    (onCancel)="onActivateUserClosed()"
  /> 
}

@if(showActivateAllUsersModal) {
  <app-activate-all-users-modal
    [showModal]="showActivateAllUsersModal"
    [persons]="inactivePersons"
    (onActivate)="onAllUsersActivated()"
    (onCancel)="onActivateAllUsersClosed()"
  /> 
}

@if(showAddParticipantsModal) {
  <app-select-additional-participants-modal
    [showModal]="showAddParticipantsModal"
    [excludePersonIds]="selectedPersonIds"
    (onAdd)="onAddedParticipants($event)"
    (onCancel)="onAddParticipantsClosed()"
  /> 
}

@if(showCreateProfileModal && selectedCreateProfilePerson) {
  <app-create-profile-modal
    [showModal]="showCreateProfileModal"
    [trainingId]="trainingId"
    [profile]="selectedCreateProfilePerson"
    (onSubmit)="onCreatedProfile($event)"
    (onCancel)="onCreateProfileClosed()"
  /> 
}

@if(showMergePersonModal && selectedMergePerson) {
  <app-merge-person-modal
    [showModal]="showMergePersonModal"
    [trainingId]="trainingId"
    [mergePerson]="selectedMergePerson"
    (onMerge)="onMergedPerson($event)"
    (onCancel)="onMergePersonClosed()"
  /> 
}